<!-- =========================================================================================
    File Name: Todo.vue
    Description: Todo Application to keep you ahead of time
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
     <div>
    <div id="todo-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
               
                <vs-sidebar class="items-no-padding" parent="#todo-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isSidebarActive">
                    
                    <VuePerfectScrollbar class="todo-scroll-area" :settings="settings" :key="$vs.rtl">
                    <todo-filters @closeSidebar="toggleTodoSidebar"></todo-filters>
                    </VuePerfectScrollbar>
                    <div class="px-6 pb-2 pt-6">
                   
                    </div>
                </vs-sidebar>
        <div :class="{'sidebar-spacer': clickNotClose}" class="no-scroll-content border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light no-scroll-content">
                    
                       <div class="flex d-theme-dark-bg items-center border border-l-0 border-r-0 border-t-0 border-solid d-theme-border-grey-light">
                        <!-- TOGGLE SIDEBAR BUTTON -->
                        <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" @click.stop="toggleTodoSidebar(true)" />
                         
                        <!-- SEARCH BAR -->
                        
                        </div>  
                            
                      

                     
                   

                    <!-- TODO LIST -->
   <VuePerfectScrollbar class="todo-content-scroll-area" :settings="settings" ref="taskListPS" :key="$vs.rtl">
    <template>
      <vs-table search  max-items="4" pagination :data="candidat" >
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          
        </div>

       
       </div>
      <template slot="thead">
      <vs-th>Nom</vs-th>
      <vs-th>Prénom</vs-th>
      <vs-th>A payé</vs-th>
      <vs-th>Payé</vs-th>
      <vs-th>Reste</vs-th>
      <vs-th>Type</vs-th>
      <vs-th>Etat</vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :state="tr.paiment == 1  ? 'success':tr.paiment == 0 ? 'danger':null" :key="indextr" v-for="(tr, indextr) in data">

        <vs-td :data="data[indextr].id">
          {{ tr.prenom }}
        </vs-td>

        <vs-td :data="data[indextr].username">
          {{ tr.nom }}
        </vs-td>

        <vs-td :data="data[indextr].id">
         <span>{{ tr.montant_paiment}} DT</span>
        </vs-td>

        <vs-td :data="data[indextr].id">
         <span>{{ tr.donner}} DT</span>
        </vs-td>

        <vs-td :data="data[indextr].id">
         <span>{{ tr.montant_paiment-tr.donner}} DT</span>
        </vs-td>
        <vs-td :data="data[indextr].id">
          
         <span v-if="tr.type_paiment==0">Total </span>
         <span v-if="tr.type_paiment==1">mois </span>
         <span v-if="tr.type_paiment==2">tremester </span>
         <span v-if="tr.type_paiment==3">session </span>
        </vs-td>
        <vs-td :data="data[indextr].id">
          <!-- <vs-checkbox v-model="tr.paiment" color="success" class="w-8 vs-checkbox-small mt-4" @click.stop /> -->
         <div v-if="tr.paiment==0"><span icon-pack="feather" icon="icon-plus" @click="promptAddNewEvent(tr)">non payé<feather-icon class="ml-2" icon="PlusIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" /></span></div> 
         <div v-if="tr.paiment==1"><span>payé</span>
         
           
           <!-- <router-link :to="'/pages/invoice/payement/'+tr.id" @click.stop.prevent class="text-inherit hover:text-primary"><feather-icon icon="DownloadIcon" svgClasses="h-5 w-5 mr-4 ml-5  hover:text-primary cursor-pointer"  /></router-link> -->

        </div>
        </vs-td>


       <template class="expand-user" slot="expand">
            <div  class="con-expand-users w-full pl-5 pr-5">
              
              <vs-table  :data="tr.history" id="table_content">

                <template slot="thead">
                  <vs-th>Date</vs-th>
                  <vs-th>montant</vs-th>
                  <vs-th>Action</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(trr, indextr) in tr.history">

                    <vs-td :data="data[indextr].email">
                      {{ data[indextr].created }}
                    </vs-td>

                    <vs-td :data="data[indextr].username">
                      {{ data[indextr].value+' DT' }}
                    </vs-td>

                    <vs-td :data="data[indextr].id">
                      <vs-button type="border" size="small" icon-pack="feather" icon="icon icon-file" class="mr-2" @click.stop="printInvoice(tr,data[indextr])"></vs-button>
                    </vs-td>
                  </vs-tr>
                </template>

              </vs-table>
              <!-- <vs-row v-for="history of tr.history" >
                    <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="4" class="mb-5">
                      {{ history.created }}
                    </vs-col>
                    <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="4" class="mb-5">
                      {{ history.value+' DT' }}
                    </vs-col>
                    <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="4" class="mb-5">
                      <vs-button type="border" size="small" icon-pack="feather" icon="icon icon-file" class="mr-2"></vs-button>
                    </vs-col>
              </vs-row> -->
              <!-- <div v-for="history of tr.history" class="con-btns-user flex items-center justify-between">
                <div class="con-userx flex items-center justify-start mt-5">
                  <span>{{ history.value+' DT' }}</span>
                  <span>{{ history.value+' DT' }}</span>
                </div>
                <div class="flex">
                  <vs-button type="border" size="small" icon-pack="feather" icon="icon-phone" class="mr-2"></vs-button>
                  <vs-button type="border" size="small" icon-pack="feather" icon="icon-send" color="success" class="mr-2"></vs-button>
                  <vs-button type="border" size="small" icon-pack="feather" icon="icon-trash" color="danger"></vs-button>
                </div>
              </div> -->
            </div>
       </template>
        
      </vs-tr>       
    </template>
    
                              </vs-table>
                            </template>

                    </VuePerfectScrollbar>
                    <!-- /TODO LIST -->
                     <!-- v-if="formateur.type!=3" -->
                    <div  class="px-4 py-4 list-item-component">
        <vs-table  :data="formateur" >
        
      <template slot="thead">
      <vs-th>Nom</vs-th>
      <vs-th>Prénom</vs-th>
      <vs-th>A payé</vs-th>
      <vs-th>Payé</vs-th>
      <vs-th>Reste</vs-th>
      <vs-th>Type</vs-th>
      <vs-th>Etat</vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :state="tr.rembourser == 1  ? 'success':tr.rembourser == 0 ? 'danger':null" :key="indextr" v-for="(tr, indextr) in data">

        <vs-td :data="data[indextr].id">
          {{ tr.prenom }}
        </vs-td>

        <vs-td :data="data[indextr].username">
          {{ tr.nom }}
        </vs-td>

        <vs-td :data="data[indextr].id">
         <span>{{ tr.montant}} DT</span>
        </vs-td>

        <vs-td :data="data[indextr].id">
         <span>{{ tr.donner}} DT</span>
        </vs-td>

        <vs-td :data="data[indextr].id">
         <span>{{ tr.montant-tr.donner}} DT</span>
        </vs-td>
        <vs-td :data="data[indextr].id">
          
         <span v-if="tr.type==0">Total </span>
         <span v-if="tr.type==1">Par heure </span>
         <span v-if="tr.type==2">Par candidat </span>
        </vs-td>
        <vs-td :data="data[indextr].id">
          <!-- <vs-checkbox v-model="tr.paiment" color="success" class="w-8 vs-checkbox-small mt-4" @click.stop /> -->
         <div v-if="tr.rembourser==0"><span icon-pack="feather" icon="icon-plus" @click="promptAddNewremboursement(tr)">non payé<feather-icon class="ml-2" icon="PlusIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" /></span></div> 
         <div v-if="tr.rembourser==1"><span>payé</span>
         
           
           <!-- <router-link :to="'/pages/invoice/payement/'+tr.id" @click.stop.prevent class="text-inherit hover:text-primary"><feather-icon icon="DownloadIcon" svgClasses="h-5 w-5 mr-4 ml-5  hover:text-primary cursor-pointer"  /></router-link> -->

        </div>
        </vs-td>


       <template class="expand-user" slot="expand">
            <div  class="con-expand-users w-full pl-5 pr-5">
              
              <vs-table  :data="tr.history" id="table_content">

                <template slot="thead">
                  <vs-th>Date</vs-th>
                  <vs-th>montant</vs-th>
                  <vs-th>Action</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(trr, indextr) in tr.history">

                    <vs-td :data="data[indextr].email">
                      {{ data[indextr].created }}
                    </vs-td>

                    <vs-td :data="data[indextr].username">
                      {{ data[indextr].value+' DT' }}
                    </vs-td>

                    <vs-td :data="data[indextr].id">
                      <vs-button type="border" size="small" icon-pack="feather" icon="icon icon-file" class="mr-2" @click.stop="printInvoiceFormateur(tr,data[indextr])"></vs-button>
                    </vs-td>
                  </vs-tr>
                </template>

              </vs-table>
              <!-- <vs-row v-for="history of tr.history" >
                    <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="4" class="mb-5">
                      {{ history.created }}
                    </vs-col>
                    <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="4" class="mb-5">
                      {{ history.value+' DT' }}
                    </vs-col>
                    <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="4" class="mb-5">
                      <vs-button type="border" size="small" icon-pack="feather" icon="icon icon-file" class="mr-2"></vs-button>
                    </vs-col>
              </vs-row> -->
              <!-- <div v-for="history of tr.history" class="con-btns-user flex items-center justify-between">
                <div class="con-userx flex items-center justify-start mt-5">
                  <span>{{ history.value+' DT' }}</span>
                  <span>{{ history.value+' DT' }}</span>
                </div>
                <div class="flex">
                  <vs-button type="border" size="small" icon-pack="feather" icon="icon-phone" class="mr-2"></vs-button>
                  <vs-button type="border" size="small" icon-pack="feather" icon="icon-send" color="success" class="mr-2"></vs-button>
                  <vs-button type="border" size="small" icon-pack="feather" icon="icon-trash" color="danger"></vs-button>
                </div>
              </div> -->
            </div>
       </template>
        
      </vs-tr>       
    </template>
    
                              </vs-table>
                      <!-- <div class="vx-row"  v-if="$route.params.filter!=':filter' && formateur.type!=3 ">
                          <vs-col   v-tooltip="'col - 3'" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                            <p >{{'Formateur: '}}</p><p class=" truncate font-semibold ml-2"  :class="{'text-success': formateur.rembourser , 'text-danger': !formateur.rembourser }">{{' '}}{{ formateur.nom}}{{' '}}{{ formateur.prenom}}  </p>
                           </vs-col>
                           <vs-col   v-tooltip="'col - 3'" vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                            <span >Salaire:   </span><p class=" truncate font-semibold ml-2"   :class="{'text-success': formateur.rembourser , 'text-danger': !formateur.rembourser }"> {{ formateur.montant}} DT <p v-if="formateur.type==1" class=" truncate font-semibold ml-2"   :class="{'text-success': formateur.rembourser , 'text-danger': !formateur.rembourser }">  </p>
                           </vs-col>
                           <vs-col   v-tooltip="'col - 3'" vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                            <span >Type:   </span><p class=" truncate font-semibold ml-2"   :class="{'text-success': formateur.rembourser , 'text-danger': !formateur.rembourser }"> <span v-if="formateur.type==0">Total</span><span v-if="formateur.type==1">Par heure</span><span v-if="formateur.type==2">Par personne</span><span v-if="formateur.type==3">Formateur salarié</span><p v-if="formateur.type==1" class=" truncate font-semibold ml-2"   :class="{'text-success': formateur.rembourser , 'text-danger': !formateur.rembourser }">  </p>
                           </vs-col>
                           <vs-col   v-tooltip="'col - 3'" vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                           <div v-if="formateur.rembourser==0"><span class="truncate font-semibold text-danger" @click="promptAddNewremboursement(formateur)">non payé<feather-icon class="ml-2" icon="PlusIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" /></span></div>
                           <div v-if="formateur.rembourser==1"> <span class="truncate font-semibold text-success">payé</span> </div>
                           <vs-button v-if="formateur.rembourser==1" type="border" size="small" icon-pack="feather" icon="icon icon-file" class="mr-2 ml-5" color="success" @click="printInvoiceFormateur(formateur)"></vs-button>
                           </vs-col>
                      </div> -->
                      <!-- <div class="vx-row"  v-if="$route.params.filter!=':filter' && formateur.type==3">
                          <vs-col   v-tooltip="'col - 3'" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                            <p >{{'Formateur: '}}</p><p class=" truncate font-semibold ml-2"  :class="{'text-success': formateur.rembourser , 'text-danger': !formateur.rembourser }">{{' '}}{{ formateur.nom}}{{' '}}{{ formateur.prenom}}  </p>
                           </vs-col>
                           <vs-col   v-tooltip="'col - 3'" vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                            <p class="text-success truncate font-semibold ml-2 ">Salairié  </p>
                           </vs-col>
                           
                           
                      </div> -->
                    
                            
                    </div>
                    <!-- <div v-if="formateur.type==3" class="px-4 py-4 mb-6 "></div> -->
                    <div class=" flex d-theme-dark-bg items-center border border-l-0 border-r-0 border-t-0 border-solid d-theme-border-grey-light">

                        <!-- TOGGLE SIDEBAR BUTTON -->
                        <feather-icon class="md:inline-flex lg:hidden ml-4 mr-5 cursor-pointer" icon="MenuIcon" @click.stop="toggleTodoSidebar(true)" />
                   <vx-card class="overflow-hidden" v-if="$route.params.filter!=':filter'">
                    <template slot="no-body">
                        <div class="flex justify-between items-center mr-4 p-1 ml-2 border border-solid d-theme-border-grey-light border-r-0 border-l-0 border-t-0">
                            <div>
                                <p><span class="font-semibold">{{this.payee}} candidat payé sur</span> <span class="font-semibold">{{this.seance.length}}</span></p>
                                <vs-progress :percent="100 * payee / this.seance.length" :color="getPopularityColor(100 * payee / this.seance.length)"></vs-progress>
                            </div>
                          <!-- <span class="font-semibold ">Payé: {{Paye}} DT</span> -->
                          <span class=" font-semibold">Total: {{total}} DT</span> 
                          <span class=" font-semibold"></span> 
                        </div>
                        <div></div>
                    </template>
                   </vx-card>
                    </div>
                    
        </div>
         
        <vs-prompt
        class="calendar-event-dialog"
        title="Ajouter un paiement"
        accept-text= "Ajouter"
        @accept="editpayement"
        @cancel="vider"
        :is-valid="validForm"
        :active.sync="activePromptAddEvent">

        
        <div class="mt-5">
          <label class="text-sm opacity-75"></label>
          <!-- <v-select :options="groupe_choices" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="groupe_data" class="mb-4 md:mb-0" v-validate="'required'"/> -->
        </div>
        <div class="mb-4">
         <vs-input class="w-full mt-4" disabled label="Montant a payé" v-model="montand_payement" v-validate="'required'" name="username" />
        </div>
        <div >
         <vs-input class="w-full mt-4" disabled label="Le reste a payé" v-model="montand_restant_payement" v-validate="'required'" name="username" />
        </div>
        <div >
         <vs-input-number min="1" :max="montand_restant_payement" class="w-full mt-4" label="A payè" v-model="montand_donner_payement" v-validate="'required'" name="montand_donner_payement" />
        </div>
        </vs-prompt>

        <vs-prompt
        class="calendar-event-dialog"
        title="Ajouter un remboursement"
        accept-text= "Ajouter"
        @accept="editremboursement"
        @cancel="vider_rembourser"
        
        :active.sync="activePromptAddrembourser">

        
        <div class="mt-5">
          <label class="text-sm opacity-75"></label>
          <!-- <v-select :options="groupe_choices" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="groupe_data" class="mb-4 md:mb-0" v-validate="'required'"/> -->
        </div>
        <div class="mb-4">
         <vs-input class="w-full mt-4" disabled label="Montant a rembourser" v-model="montand_rembourser" v-validate="'required'" name="username" />
        </div>
        <div >
         <vs-input class="w-full mt-4" disabled label="Le reste a rembourser" v-model="montand_restant_rembourser" v-validate="'required'" name="username" />
        </div>
        <div >
         <vs-input-number min="1" :max="montand_restant_rembourser" class="w-full mt-4" label="A rembourser" v-model="montand_donner_rembourser" v-validate="'required'" name="montand_donner_rembourser" />
        </div>
        </vs-prompt>
        

                <!-- EDIT TODO DIALOG -->
                <!-- todo-edit :displayPrompt="displayPrompt" :taskId="taskIdToEdit" @hideDisplayPrompt="hidePrompt" v-if="displayPrompt"></todo-edit -->
    </div>
    <div>
      <vx-card id="invoice-container">

            <!-- INVOICE METADATA -->
            <div class="vx-row leading-loose p-base">
                <div class="vx-col w-full md:w-1/2 mt-base">
                    <img src="@/assets/images/logo/logo.png" style="width: 200px; height: 70px;" alt="vuexy-logo">
                </div>
                <div class="vx-col w-full md:w-1/2 text-right">
                    <h1 id="Recu_de_Paiment">Reçu de Paiment </h1>
                    <div class="invoice__invoice-detail mt-6">
                        
                        <h6 class="mt-4">DATE DE PAIEMENT</h6>
                        <p id="created_at_invoiceDetails">{{ invoiceDetails.invoiceDate | date(true) }}</p>
                    </div>
                </div>
                <div class="vx-col w-full md:w-1/2 mt-12">
                    
                    <div class="invoice__recipient-info my-4">
                        <p id="ref_invoiceDetails">ID transaction: {{ '#'+198000+recipientDetails.id }}</p>
                        <p id="nom_invoiceDetails">Nom: {{ recipientDetails.nom }}</p>
                        <p id="prenom_invoiceDetails">Prénom: {{ recipientDetails.prenom }}</p>
                        <p id="value_invoiceDetails">Montant: {{ recipientDetails.montant }}</p>
                        <!-- <p>Nom:{{ recipientDetails.zipcode }}</p> -->
                    </div>
                    <div class="invoice__recipient-contact ">
                        <p class="flex items-center">
                            <feather-icon icon="MailIcon" svgClasses="h-4 w-4"></feather-icon>
                            <span id="mailId_invoiceDetails" class="ml-2">{{ recipientDetails.mailId }}</span>
                        </p>
                        <p class="flex items-center">
                            <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4"></feather-icon>
                            <span id="mobile_invoiceDetails" class="ml-2">{{ recipientDetails.mobile }}</span>
                        </p>
                    </div>
                </div>
                
            </div>
            <hr />
            <!-- INVOICE METADATA -->
            <div class="vx-row leading-loose p-base">
                <div class="vx-col w-full md:w-1/2 mt-base">
                    <img src="@/assets/images/logo/logo.png" style="width: 200px; height: 70px;" alt="vuexy-logo">
                </div>
                <div class="vx-col w-full md:w-1/2 text-right">
                    <h1 id="Recu_de_Paiment2">Reçu de Paiment</h1>
                    <div class="invoice__invoice-detail mt-6">
                        

                        <h6 class="mt-4">INVOICE DATE</h6>
                        <p id="created_at_invoiceDetails_d">{{ invoiceDetails.invoiceDate | date(true) }}</p>
                    </div>
                </div>
                <div class="vx-col w-full md:w-1/2 mt-12">
                    <h5>Recipient</h5>
                    <div class="invoice__recipient-info my-4">
                      <p id="ref_invoiceDetails_d">ID transaction: {{ '#'+298000+recipientDetails.id }}</p>
                        <p id="nom_invoiceDetails_d">Nom: {{ recipientDetails.nom }}</p>
                        <p id="prenom_invoiceDetails_d">Prénom: {{ recipientDetails.prenom }}</p>
                        <p id="value_invoiceDetails_d">Montant: {{ recipientDetails.montant }}</p>
                        <!-- <p>Nom:{{ recipientDetails.zipcode }}</p> -->
                    </div>
                    <div class="invoice__recipient-contact ">
                        <p class="flex items-center">
                            <feather-icon icon="MailIcon" svgClasses="h-4 w-4"></feather-icon>
                            <span id="mailId_invoiceDetails_d" class="ml-2">{{ recipientDetails.mailId }}</span>
                        </p>
                        <p class="flex items-center">
                            <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4"></feather-icon>
                            <span id="mobile_invoiceDetails_d" class="ml-2">{{ recipientDetails.mobile }}</span>
                        </p>
                    </div>
                </div>
                
            </div>
      </vx-card>
    </div>
    

    </div>
</template>

<script>
import moduleTodo          from '@/store/todo/moduleTodo.js'
//import TodoAddNew          from "./TodoAddNew.vue"
//import TodoTask            from "./TodoTask.vue"
import TodoFilters         from "./candidatFilters.vue"
//import TodoEdit            from "./TodoEdit.vue"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleclasse from '@/store/classe/moduleclasse.js'
// import Invoice from '../../pages/Invoice.vue'


export default {
  data() {
    return {
      mailTo: "",
            companyDetails: {
                name: 'Microsion Technologies Pvt. Ltd.',
                addressLine1: '9 N. Sherwood Court',
                addressLine2: 'Elyria, OH',
                zipcode: '94203',
                mailId: 'hello@pixinvent.net',
                mobile: '+91 999 999 9999',
            },
            recipientDetails: {
                nom: null,
                prenom: null,
                montant: null,
                mailId: null,
                mobile: null,
            },
            invoiceDetails: {
                invoiceNo: null,
                invoiceDate: null,
                // invoiceDate: 'Mon Dec 10 2018 07:46:00 GMT+0000 (GMT)',
            },
      this_filter:0,  
      id_payement: 0,
      id_rembourser: 0,
      montand_restant_payement: 0,
      montand_donner_payement: 0,
      montand_payement: 0,
      montand_restant_rembourser: 0,
      montand_donner_rembourser: 0,
      montand_rembourser: 0,
      
      activePromptAddEvent: false,
      activePromptAddrembourser: false,
      forma:[],
      seance:[],
      currFilter           : "",
      clickNotClose        : true,
      displayPrompt        : false,
      taskIdToEdit         : 0,
      isSidebarActive      : true,
      settings : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.30,
      },
    }
  },
  watch: {
    
    todoFilter() {
      
      this.$store.dispatch("classe/fetchCandidats",this.$route.params.filter).catch(err => { console.error(err) })
      this.$store.dispatch("classe/fetchFormateur",this.$route.params.filter).catch(err => { console.error(err) })
      // window.document.getElementById('table_content').remove()
      this.$refs.taskListPS.$el.scrollTop = 0
      this.toggleTodoSidebar()

      // Fetch Tasks
      this.this_filter= this.$route.params.filter
      let filter = this.$route.params.filter
      console.log('1',filter)
      
       
      //this.$store.dispatch("todo/fetchTasks", { filter: filter })
      //this.$store.commit("todo/UPDATE_TODO_FILTER", filter)
    },
    windowWidth() {
      this.setSidebarWidth()
    },
  },
  computed: {
    
    payee(){
        let resultat = 0
        for (var paiment of this.$store.state.classe.candidats) {
              if(paiment.paiment==1) {
                  resultat ++
                  
                  }
        }
        return resultat
    },
    Paye(){
        let resultat = 0
        for (var paiment of this.$store.state.classe.candidats) {
              if(paiment.paiment==1) {
                  resultat = resultat + paiment.montant_paiment 
                  this.payee ++
                  }
        }
        return resultat
    },
    total(){
        let resultat = 0
        for (var paiment of this.$store.state.classe.candidats) {
                 resultat = resultat + paiment.montant_paiment 
        }
        return resultat
    },
    isCompleted: {
          get () {
              //return this.taskLocal.isCompleted
          },
          set (value) {
            /*this.$store.dispatch("todo/updateTask", Object.assign({}, this.taskLocal, {isCompleted: value}))
              .then((response) => {
                this.taskLocal.isCompleted = response.data.isCompleted
              })
              .catch((error) => { console.error(error) })*/
            
            console.log(value)
          },},
    formateur(){
      //let forma = []
     this.forma = this.$store.state.classe.formateur
     console.log('this.formateur',this.forma)
     return this.forma
    },
    candidat()    { this.seance = this.$store.state.classe.candidats 
                   
                   return     this.seance        },
    todo()        { return this.$store.state.todo.todoArray              },
    todoFilter()  { return this.$route.params.filter                     },
    taskList()    { return this.$store.getters["todo/queriedTasks"]      },
    searchQuery:  {
      get()       { return this.$store.state.todo.todoSearchQuery        },
      set(val)    { this.$store.dispatch('todo/setTodoSearchQuery', val) }
    },
    windowWidth() { return this.$store.state.windowWidth }
  },
  methods: {
    
    printInvoice(data,history){

       this.recipientDetails.nom = data.nom
       this.recipientDetails.prenom = data.prenom
       this.recipientDetails.montant = history.value
       this.recipientDetails.mailId = data.email
       this.recipientDetails.mobile = data.mobile
        
        this.invoiceDetails.invoiceNo = history.value
        this.invoiceDetails.invoiceDate = history.created
        // this.printfin(data,history)
        console.log('data',data)
        window.document.getElementById('Recu_de_Paiment').innerHTML='Reçu candidat'
        window.document.getElementById('Recu_de_Paiment2').innerHTML='Reçu center'
        
        window.document.getElementById('ref_invoiceDetails').innerHTML='ID transaction: '+'#'+690+data.id+'F'+190+history.id
        window.document.getElementById('nom_invoiceDetails').innerHTML='Nom: '+data.nom
        window.document.getElementById('prenom_invoiceDetails').innerHTML='Prénom: '+data.prenom
        window.document.getElementById('mailId_invoiceDetails').innerHTML=data.email
        window.document.getElementById('mobile_invoiceDetails').innerHTML=data.mobile
        window.document.getElementById('value_invoiceDetails').innerHTML='Montant: '+history.value+ ' DT'
        window.document.getElementById('created_at_invoiceDetails').innerHTML=history.created

        window.document.getElementById('ref_invoiceDetails_d').innerHTML='ID transaction: '+'#'+690+data.id+'F'+190+history.id
        window.document.getElementById('nom_invoiceDetails_d').innerHTML='Nom: '+data.nom
        window.document.getElementById('prenom_invoiceDetails_d').innerHTML='Prénom: '+data.prenom
        window.document.getElementById('mailId_invoiceDetails_d').innerHTML=data.email
        window.document.getElementById('mobile_invoiceDetails_d').innerHTML=data.mobile

        window.document.getElementById('value_invoiceDetails_d').innerHTML='Montant: '+history.value+ ' DT'
        window.document.getElementById('created_at_invoiceDetails_d').innerHTML=history.created
        window.print()
       
    },
    printInvoiceFormateur(data,history){

      //  this.recipientDetails.nom = data.nom
      //  this.recipientDetails.prenom = data.prenom
      //  this.recipientDetails.montant = history.value
      //  this.recipientDetails.mailId = data.email
      //  this.recipientDetails.mobile = data.mobile
        
      //   this.invoiceDetails.invoiceNo = history.value
      //   this.invoiceDetails.invoiceDate = history.created
        // this.printfin(data,history)
        // console.log(data)
        window.document.getElementById('ref_invoiceDetails').innerHTML='ID transaction: '+'#'+690+data.id+'F'+190+history.id
        window.document.getElementById('Recu_de_Paiment').innerHTML='Reçu Formateur'
        window.document.getElementById('Recu_de_Paiment2').innerHTML='Reçu center'
        window.document.getElementById('nom_invoiceDetails').innerHTML='Nom: '+data.nom
        window.document.getElementById('prenom_invoiceDetails').innerHTML='Prénom: '+data.prenom
        window.document.getElementById('mailId_invoiceDetails').innerHTML=data.email
        window.document.getElementById('mobile_invoiceDetails').innerHTML=data.mobile

        window.document.getElementById('value_invoiceDetails').innerHTML='Montant: '+history.value+ ' DT'
        window.document.getElementById('created_at_invoiceDetails').innerHTML=history.created

        window.document.getElementById('ref_invoiceDetails_d').innerHTML='ID transaction: '+'#'+690+data.id+'F'+190+history.id
        window.document.getElementById('nom_invoiceDetails_d').innerHTML='Nom: '+data.nom
        window.document.getElementById('prenom_invoiceDetails_d').innerHTML='Prénom: '+data.prenom
        window.document.getElementById('mailId_invoiceDetails_d').innerHTML=data.email
        window.document.getElementById('mobile_invoiceDetails_d').innerHTML=data.mobile

        window.document.getElementById('value_invoiceDetails_d').innerHTML='Montant: '+history.value+ ' DT'
        window.document.getElementById('created_at_invoiceDetails_d').innerHTML=history.created
        window.print()
       
    },
    payement_formateur(formateur){
      
      
     this.confirmpayement_formateur(formateur)
    },
    payement_f(){
    console.log(this.forma[0])

    this.$store.dispatch("classe/updateRembourser_formateur_formation", this.forma[0])
    this.$store.dispatch("classe/fetchFormateur",this.$route.params.filter).catch(err => { console.error(err) })
    this.showMessage('danger', 'title', 'text')
    },
    confirmpayement_formateur(formateur) {
            this.$vs.dialog({
              type: 'confirm',
              color: 'success',
              title: `Confirmation remboursement`,
              text: `formateur "${formateur.id}" montant "${formateur.montant}"`,
              accept: this.payement_f,
              acceptText: "rembourser"
            })
          },
    showMessage(color, title, text) {
              this.$vs.notify({
                color: color,
                title: title,
                text: text
              })
            },
    vider(){
      this.activePromptAddEvent=false
      this.id_payement= 0
      this.montand_restant_payement= 0
      this.montand_donner_payement= 0
      this.montand_payement= 0
    },
    vider_rembourser(){
      this.activePromptAddrembourser=false
      this.id_rembourser= 0
      this.montand_restant_rembourser= 0
      this.montand_donner_rembourser= 0
      this.montand_rembourser= 0
    },
    editpayement() {
      let payement_test = 0
      
      this.montand_restant_payement = this.montand_restant_payement - this.montand_donner_payement 
      console.log(this.montand_restant_payement)
      if(this.montand_restant_payement==0){
         payement_test = 1
      }
      const obj = {id:this.id_payement, donner: this.montand_donner_payement, paiment: payement_test }
      console.log(1,obj)
      //obj.classes = "event-" + this.labelColor(this.labelLocal)
      this.$store.dispatch("classe/updateParticipation_candidat_formation", obj).catch(err => { console.error(err) }).then(()   => { 
        this.showMessage('success', 'update', 'paiment is update')
        this.$store.dispatch("classe/fetchCandidats",this.$route.params.filter).catch(err => { console.error(err) })
        this.$store.dispatch("classe/fetchFormateur",this.$route.params.filter).catch(err => { console.error(err) })
         })
      
      this.vider()
      
      // this.$store.dispatch("classe/fetchCandidats",this.$route.params.filter).catch(err => { console.error(err) })
      // this.$store.dispatch("classe/fetchFormateur",this.$route.params.filter).catch(err => { console.error(err) })
      // this.$store.dispatch("classe/fetchCandidats",this.$route.params.filter).catch(err => { console.error(err); })
      // this.$store.dispatch("classe/fetchFormateur",this.$route.params.filter).catch(err => { console.error(err) })
      
    },
    editremboursement(){

      let payement_test = 0
      this.montand_restant_rembourser = this.montand_restant_rembourser - this.montand_donner_rembourser 
      console.log(this.montand_restant_rembourser)
      if(this.montand_restant_rembourser==0){
         payement_test = 1
      }
      const obj = {id:this.id_rembourser, donner: this.montand_donner_rembourser, rembourser: payement_test }
      console.log('obj',obj)
      //obj.classes = "event-" + this.labelColor(this.labelLocal)
      this.$store.dispatch("classe/updateRembourser_formateur_formation", obj).catch(err => { console.error(err) }).then(()   => {
         this.showMessage('success', 'update', 'paiment is update') 
         this.$store.dispatch("classe/fetchCandidats",this.$route.params.filter).catch(err => { console.error(err) })
         this.$store.dispatch("classe/fetchFormateur",this.$route.params.filter).catch(err => { console.error(err) })
         })
      
      this.vider_rembourser()
      
    },
    promptAddNewEvent(date) {
        this.disabledFrom = false;
        this.addNewEventDialog(date);
    },
    promptAddNewremboursement(date) {
        
        this.disabledFrom = false;
        this.addNewremboursementDialog(date);
    },
    addNewEventDialog(date) {
        
        this.id_payement= date.id
        this.montand_payement = date.montant_paiment
        this.montand_restant_payement = date.montant_paiment - date.donner
        this.montand_donner_payement= 0
        this.activePromptAddEvent = true
    },
    addNewremboursementDialog(date) {
        // alert(date.montant)
        this.id_rembourser= date.id
        this.montand_rembourser = date.montant
        this.montand_restant_rembourser = date.montant - date.donner
        this.montand_donner_rembourser= 0
        this.activePromptAddrembourser = true
        // alert('er')
    },
    getPopularityColor(num) {
      if(num > 90) return "success"
      if(num >70) return "primary"
      if(num >= 50) return "warning"
      if(num < 50) return "danger"
      return "primary"
    },
    reset(){
     this.$store.dispatch("classe/fetchCandidats",this.$route.params.filter).catch(err => { console.error(err) })
     this.$store.dispatch("classe/fetchFormateur",this.$route.params.filter).catch(err => { console.error(err) })
    
    },
    
    showMessage(color, title, text) {
              this.$vs.notify({
                color: color,
                title: 'User '+title,
                text: 'The new user was '+text
              })
            },
    showDisplayPrompt(itemId) {
      this.taskIdToEdit  = itemId
      this.displayPrompt = true
    },
    hidePrompt() {
      this.displayPrompt = false
    },
    setSidebarWidth() {
      if (this.windowWidth < 992) {
        this.isSidebarActive = this.clickNotClose = false
      } else {
        this.isSidebarActive = this.clickNotClose = true
      }
    },
    toggleTodoSidebar(value = false) {
      if (!value && this.clickNotClose) return
      this.isSidebarActive = value
    },
  },
  components: {
    //TodoAddNew,
    //TodoTask,
    TodoFilters,
    //TodoEdit,
    VuePerfectScrollbar
  },
  created() {
    //formation
    let filter = this.$route.params.filter
    console.log('3',filter)
    if(!moduleclasse.isRegistered) {
      this.$store.registerModule('classe', moduleclasse)
      moduleclasse.isRegistered = true
    }
    this.$store.dispatch("classe/fetchCandidats",this.$route.params.filter).catch(err => { console.error(err) })
    //console.log('1200',this.$store.state.seance.participation_candidat_seance)
    this.$store.dispatch("classe/fetchFormateur",this.$route.params.filter).catch(err => { console.error(err) })

    console.log('tt',this.$route.params.filter)
    
    //
    this.$store.registerModule('todo', moduleTodo)
    this.setSidebarWidth()

    
    // Fetch Tasks
    this.$store.dispatch("todo/fetchTasks", { filter: filter })
    this.$store.commit("todo/UPDATE_TODO_FILTER", filter)

    // Fetch Tags
    this.$store.dispatch("todo/fetchTags")
  },
  beforeUpdate() {
    this.currFilter = this.$route.params.filter
  },
  beforeDestroy: function() {
    this.$store.unregisterModule('todo')
  },
  mounted() {
    this.$store.dispatch("todo/setTodoSearchQuery", "")
  }
}

</script>


<style lang="scss">
.no-scroll.navbar-floating .no-scroll-content {
    height: 100%;
}
hr {
	height: none;
	border: none;
	border-top: 1px dashed grey;
}
@import "@/assets/scss/vuexy/apps/todo.scss";
#invoice-container,
#invoice-container * {
      display: none;
    }
</style>
<style lang="scss">
@media print {
  
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    #invoice-container,
    #invoice-container * {
      display: block;
      visibility: visible;
    }
    #invoice-container {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  
}
</style>
